import { Stack } from "@/core/components/ui/stack";
import {
  StAdjustmentsPreview,
  StAdjustmentsView,
  useStAdjustmentsSection,
} from "./st-adjustments";

// PushPay ServiceTitan payroll adjustments for the period on screen.
//
// The fixed-height envelope is the tab contract (same as PayPacks): the view's
// internal `flex-1` table fills the tab and scrolls inside itself rather than
// growing the page.
//
// State lives in `StAdjustmentsSectionProvider`, mounted above the page header
// so the push action and the technician pane can read it too. Run-change resets
// happen there rather than at a keyed boundary here — this tab is no longer the
// only reader, and remounting it would leave the other two holding stale state.
export const PayBreakdownAdjustmentsTab = () => {
  const { isPreview } = useStAdjustmentsSection();

  return (
    <Stack
      gap="none"
      align="stretch"
      fullWidth
      className="h-[calc(100dvh-180px)] max-h-[1200px] min-h-[520px] min-w-0"
    >
      {isPreview ? <StAdjustmentsPreview /> : <StAdjustmentsView />}
    </Stack>
  );
};
